import SignUpPage from "./components/pages/authentication/SignUpPage";
import SideNavbar from "./components/SideNav"
import DashboardPage from "./components/pages/dashboard/DashboardPage";
import SignInPage from "./components/pages/authentication/SignIn";
import WorkersCategoryPage from "./components/pages/workers/WorkersCategoriesPage";
import SubCategoryPage from "./components/pages/workers/WorkerSubCatPage";
import DoorstepServices from "./components/pages/doorstepServices/DoorstepServices";
import DoorstepCategories from "./components/pages/doorstepServices/DoorstepCategories";
import Users from "./components/pages/userInfo/Users";
import Workers from "./components/pages/workers/Workers";
import ProfessionalServices from "./components/pages/doorstepServices/professionalServices";
import WorkRequirements from "./components/pages/requirements/Requirements";
import DoorstepOrders from "./components/pages/doorstepServices/DoorstepOrders";
import SubscriptionPlans from "./components/pages/subscription&Membership/SubscriptionPlans";
import MembershipPlans from "./components/pages/subscription&Membership/MembershipPlans";
import HelpAndSupport from "./components/pages/common/HelpAndSupport";
import RequirementValues from "./components/pages/requirements/RequirementValues";
import SubscriptionFeatures from "./components/pages/subscription&Membership/SubscriptionFeatures";
import WithdrawalRequests from "./components/pages/common/WithdrawRequests";
import MembershipSales from "./components/pages/subscription&Membership/MembershipSales";
import SubscriptionSales from "./components/pages/subscription&Membership/SubscriptionSales";
import TransactionDetails from "./components/pages/transactions/Transaction";
import Reviews from "./components/pages/reviews/Reviews";
import UserDetailsPage from "./components/pages/common/detail_pages/UserDetailsPage";
import WorkerDetailsPage from "./components/pages/common/detail_pages/WorkerDetailsPage";
import WorkerEditPage from "./components/pages/common/edit_pages/WorkerEditPage";
import UserEditPage from "./components/pages/common/edit_pages/UserEditPage";
import DoorstepOrderDetailsPage from "./components/pages/common/detail_pages/DoorstepOrderDetailsPage";
import RequirementDetailsPage from "./components/pages/common/detail_pages/RequirementDetaisl";
import DoorstepServiceDetailsPage from "./components/pages/common/detail_pages/DoorstepServiceDetails";
import TransactionDetailsPage from "./components/pages/common/detail_pages/TransactionDetailsPage";
import HelpAndSupportDetailsPage from "./components/pages/common/detail_pages/HelpAndSupportDetailsPage";
import MembershipAndSalesDetailsPage from "./components/pages/common/detail_pages/MemberhsipAndSubscriptionDetails";
import DoorstepServiceEditPage from "./components/pages/common/edit_pages/DoorstepServiceEditPage";

const adminDashboardRoutes = [
    {
        path: "/home",
        element: DashboardPage,
    },
    {
        path: "/sidenav",
        element: SideNavbar
    },
    {
        path: "/sign-up",
        element: SignUpPage
    },
    {
        path: "/sign-in",
        element: SignInPage
    },
    {
        path: "/worker/category",
        element: WorkersCategoryPage
    },
    {
        path: "/worker/sub-categories",
        element: SubCategoryPage
    },
    {
        path: "/doorstep/categories",
        element: DoorstepCategories
    },

    {
        path: "/users",
        element: Users
    },
    {
        path: "/users/:id",
        element: UserDetailsPage
    },
    {
        path: "/users/edit/:id",
        element: UserEditPage
    },
    {
        path: "/workers",
        element: Workers
    },
    {
        path: "/workers/edit/:id",
        element: WorkerEditPage
    },
    {
        path: "/workers/:id",
        element: WorkerDetailsPage
    },
    {
        path: "/doorstep/services",
        element: DoorstepServices
    },
    {
        path: "/doorstep/services/:id",
        element: DoorstepServiceDetailsPage
    },
    {
        path: "/doorstep/services/edit/:id",
        element: DoorstepServiceEditPage
    },
    {
        path: "/doorstep/services/create",
        element: DoorstepServiceEditPage
    },
    {
        path: "/professional/services",
        element: ProfessionalServices
    },
    {
        path: "/professional/services/:id",
        element: DoorstepServiceDetailsPage
    },
    {
        path: "/professional/services/edit/:id",
        element: DoorstepServiceEditPage
    },
    {
        path: "/professional/services/create",
        element: DoorstepServiceEditPage
    },
    {
        path: "/requirements",
        element: WorkRequirements
    },
    {
        path: "/requirements/:id",
        element: RequirementDetailsPage
    },
    {
        path: "requeriment-values",
        element: RequirementValues
    },
    {
        path: "/doorstep-orders",
        element: DoorstepOrders
    },
    {
        path: "/doorstep-orders/:id",
        element: DoorstepOrderDetailsPage
    },
    {
        path: "/subscriptions/plans",
        element: SubscriptionPlans
    },
    {
        path: "/membership/plans",
        element: MembershipPlans
    },
    {
        path: "/support",
        element: HelpAndSupport
    },
    {
        path: "/support/:id",
        element: HelpAndSupportDetailsPage
    },
    {
        path: "/feature-values",
        element: SubscriptionFeatures
    },
    {
        path: "/withdraw-requests",
        element: WithdrawalRequests
    },
    {
        path: "/membership/sales",
        element: MembershipSales
    },
    {
        path: "/membership/sales/:id",
        element: MembershipAndSalesDetailsPage
    },
    {
        path: "/subscription/sales",
        element: SubscriptionSales
    },
    {
        path: "/subscription/sales/:id",
        element: MembershipAndSalesDetailsPage
    },
    {
        path: "/transactions",
        element: TransactionDetails
    },
    {
        path: "/transactions/:id",
        element: TransactionDetailsPage
    },
    {
        path: "/reviews",
        element: Reviews
    },



]

export default adminDashboardRoutes;